import { useState } from "react";
import * as convert from "../constant/Convert.helper"

export function HistoryTransferPackage(props) {
  const [customerId, setCustomerId] = useState(null);

  return (
    <div className="order-popup history-credit">
      <div className="popup-cent">
        <div className="content-popup fadeInDown">
          <div className="head-popup">
            <div className="title">
              Lịch sử chuyển nhượng thẻ
            </div>
          </div>
          <div className="body-popup">
            <div className="panel-body">
              {props.dataHistoryTransferPackage.length > 0 ?
                <div className="fixed-content-wrapper customer-list-container">
                  <div className="fixed-one-col">
                    <div className="dataTables_wrapper no-footer no-padding mt-10">
                        <table className="table table-hover datatable-columns no-padding no-footer ng-isolate-scope dataTable">
                            <thead>
                                <tr>
                                  <th>Tên thẻ</th>
                                  <th>Khách chuyển</th>
                                  <th>Khách nhận</th>
                                  <th>Ghi chú</th>
                                  <th>Ngày thao tác</th>
                                  <th>Người thao tác</th>
                                  <th>Cơ sở</th>
                                </tr>
                            </thead>
                            <tbody>
                              {props.dataHistoryTransferPackage.map((item, key) => (
                                <tr key={key} >
                                  <td className={item.reason == "Chuyển cọc" || item.reason == "Thanh toán order" ? "price_credit minus" : "price_credit plus"}>
                                    {item.package_name}
                                  </td>
                                  <td>{item.customer_old_name} <br/> {item.customer_old_mobile}</td>
                                  <td>{item.customer_new_name} <br/> {item.customer_new_mobile}</td>
                                  <td style={{"width": "200px"}}>{item.note ?? null}</td>
                                  <td>{convert.convertDateTime(item.created_at)}</td>
                                  <td>{item.created_by_name ?? ''}</td>
                                  <td>{item.store_name ?? ''}</td>
                                </tr>
                              ))}
                            </tbody>
                        </table>
                    </div>
                  </div>
                </div>
              : "Không có dữ liệu phù hợp"}
            </div>
          </div>
          <div className="bottom-popup">
            <div className="button-container">
              <div className="button-cent style3" onClick={props.onHandelPopup}>
                <span><i className="fas fa-times"></i></span>Đóng
              </div>
            </div>
          </div>
        </div>
        <div onClick={props.onHandelPopup} className="overlay"></div>
      </div>
    </div>
  );
}
